/**
 * Keeps unbounded display values within responsive containers across features.
 */
import React from 'react';
import Text from '@amzn/meridian/text';

interface ShrinkableTextValueProps {
  children: React.ReactNode;
  testId: string;
  type?: 'b200' | 'b300';
}

export const ShrinkableTextValue: React.FC<ShrinkableTextValueProps> = ({
  children,
  testId,
  type,
}) => (
  <div data-testid={testId} style={{ minWidth: 0, overflow: 'hidden' }}>
    <Text breakWord={true} type={type}>{children}</Text>
  </div>
);
